import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
  InputNumber,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth, ReferenceTypeCodes } from "_helpers";
import { companyService, referenceService } from "_services";
import TabMenu from "./TabMenu";

function Summary({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [company, setCompany] = useState({});
  const [companyTypes, setCompanyTypes] = useState([]);
  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [businessCategories, setBusinessCategories] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    getItem(id);
    getCompanyTypes();
    getRegions();
    getCountries();
    getBusinessCategories();
    getCompanies();
  }, []);

  const getItem = (itemId) => {
    setIsLoading(true);
    companyService
      .getById(itemId)
      .then((x) => {
        setIsLoading(false);
        const item = x.content;
        item.companyTypes = item.companyTypes.map((type) => type.id);
        setCompany(item);
        onFill(item);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getCompanyTypes = () => {
    setIsLoading(true);
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.COMPANY_TYPE)
      .then((x) => {
        setIsLoading(false);
        setCompanyTypes(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getRegions = () => {
    setIsLoading(true);
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.REGION)
      .then((x) => {
        setIsLoading(false);
        setRegions(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getCountries = () => {
    setIsLoading(true);
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.COUNTRY)
      .then((x) => {
        setIsLoading(false);
        setCountries(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getBusinessCategories = () => {
    setIsLoading(true);
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.INDUSTRY_TYPE)
      .then((x) => {
        setIsLoading(false);
        setBusinessCategories(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getCompanies = () => {
    setIsLoading(true);
    companyService
      .getSuggestion("")
      .then((x) => {
        setIsLoading(false);
        setCompanies(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        values.companyTypes = values.companyTypes.map((id) => ({
          id,
        }));
        companyService
          .update(id, values)
          .then(() => {
            message.success("Successfully updated!");
            setIsLoading(false);
            history.push(`${path}`);
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCancel = () => {
    history.push("/companies");
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Popconfirm
          title="Are you sure to update the changes?"
          onConfirm={handleFormSumbit}
        >
          <Button key="1" type="primary" htmlType="submit" loading={isLoading}>
            Save
          </Button>
        </Popconfirm>
      );
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/companies">Company Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`.replace(":id", id)}>
                Company: {company.code}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <TabMenu menu="summary" id={id} />
          <Form
            form={form}
            name="form-create"
            layout="vertical"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  name="code"
                  label="Company Code"
                  rules={[
                    { required: true, message: "Company Code is required" },
                  ]}
                >
                  <Input
                    placeholder="Company Code"
                    disabled={!Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="companyTypes"
                  label="Company Types"
                  rules={[
                    { required: true, message: "Company Type is required" },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    showArrow={false}
                    optionFilterProp="children"
                    placeholder="Please select"
                    mode="multiple"
                  >
                    {companyTypes.length > 0 &&
                      companyTypes.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="vatNo" label="VAT Number">
                  <Input placeholder="VAT Number" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  name="name"
                  label="Company Name"
                  rules={[
                    { required: true, message: "Company Name is required" },
                  ]}
                >
                  <Input placeholder="Company Name" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name={["region", "id"]} label="Region">
                  <Select placeholder="Please select">
                    {regions.map((t) => (
                      <Option value={t.id} key={t.id}>
                        {t.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="importerNo" label="Importer Number">
                  <Input placeholder="Importer Number" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="alternateCode" label="Alternate Code">
                  <Input placeholder="Alternate Code" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name={["country", "id"]} label="Country">
                  <Select placeholder="Please select">
                    {countries.map((t) => (
                      <Option value={t.id} key={t.id}>
                        {t.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="tiepApprovalNo" label="TIEP Approval Number">
                  <Input placeholder="TIEP Approval Number" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="alternateName" label="Alternate Name">
                  <Input placeholder="Alternate Name" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name={["industryType", "id"]}
                  label="Business Category"
                >
                  <Select placeholder="Please select">
                    {businessCategories.map((t) => (
                      <Option value={t.id} key={t.id}>
                        {t.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="tiepSchemeType" label="TIEP Schema Type">
                  <Input placeholder="TIEP Schema Type" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name={["parent", "id"]} label="Parent Company">
                  <Select placeholder="Please select" allowClear>
                    {companies.length > 0 &&
                      companies.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="emails" label="Emails">
                  <Input placeholder="Emails" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="maxPoLines"
                  label="Max PO LinesMaximum PO Lines"
                >
                  <InputNumber placeholder="Maximum PO Lines" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}></Col>
              <Col span={8}></Col>
              <Col span={8}>
                <Form.Item name="minimumOrderValue" label="Minimum Order Value">
                  <InputNumber placeholder="Minimum Order Value" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Summary;
